// Shared date helpers.
//
// Backend writes timestamps in two shapes:
//   1. `datetime.now(timezone.utc).isoformat()` → "2026-04-30T09:47:15.123456+00:00"
//   2. Raw `datetime` objects stored in Mongo that FastAPI then serialises
//      as "2026-04-30T09:47:15.123456" (no Z, no offset).
//
// JavaScript's `new Date("…")` parses shape #1 correctly as UTC but parses
// shape #2 as LOCAL time — which caused Simon's EST calls to show 9:47am
// instead of 5:47am (UTC treated as if it were his local clock).
//
// `parseServerDate` guarantees the returned Date is correct: anything
// lacking a timezone designator is assumed UTC (because every write path
// on the backend stores UTC).
export function parseServerDate(raw) {
  if (!raw) return null;
  if (raw instanceof Date) return raw;
  if (typeof raw !== 'string') return new Date(raw);
  // Already has Z or an offset (+hh:mm / -hh:mm) → parse as-is.
  if (/(Z|[+-]\d{2}:?\d{2})$/.test(raw)) return new Date(raw);
  // Looks like an ISO8601 naked timestamp → append Z so JS treats as UTC.
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(raw)) return new Date(raw + 'Z');
  return new Date(raw);
}

// Generic locale string rendering — use when the user's own local time
// is appropriate (e.g. admin oversight pages).
export function formatServerTs(raw) {
  const d = parseServerDate(raw);
  if (!d || isNaN(d.getTime())) return '';
  try { return d.toLocaleString(); } catch { return String(raw); }
}
